import axios from "axios";
import axiosInstance from "../../../config/axiosConfig";

export interface BankDetails {
  id?: string;
  leadId: string;
  applicationId: string;
  bankName: string;
  ifsc: string;
  branchName: string;
  customerId?: string;
  accountNumber: string;
  accountType: string;
}

export interface BankResponse {
  id: string;
  leadId: string;
  applicationId: string;
  bankName: string;
  ifsc: string;
  branchName: string;
  customerId?: string;
  accountNumber: string;
  accountType: string;
}

export interface GetBanksResponse {
  bankAccounts: BankResponse[];
  count: number;
}

export const bankService = {
  createBank: async (bankData: BankDetails): Promise<BankResponse> => {
    try {
      const response = await axiosInstance.post("/applications/banks", bankData);
      return response.data;
    } catch (error) {
      console.error("Error creating bank account:", error);
      throw error;
    }
  },

  getBanksByApplicationId: async (applicationId: string): Promise<GetBanksResponse> => {
    try {
      const response = await axiosInstance.get(`/applications/banks?applicationId=${applicationId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching bank accounts:", error);
      throw error;
    }
  },

  updateBank: async (bankData: BankDetails): Promise<BankResponse> => {
    try {
      const response = await axiosInstance.post("/applications/banks", bankData);
      return response.data;
    } catch (error) {
      console.error("Error updating bank account:", error);
      throw error;
    }
  },

  deleteBank: async (bankId: string): Promise<void> => {
    try {
      await axiosInstance.delete(`/applications/banks/${bankId}`);
    } catch (error) {
      console.error("Error deleting bank account:", error);
      throw error;
    }
  }
};
